export const GROUP_SELECTION_ID = "__canvas-group__";
export const GROUP_SELECTION_COLOR = "#18181B";

export const axisAlignedBounds = (boxes = []) => {
  if (!boxes.length) return null;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  boxes.forEach((box) => {
    const x = Number(box.x) || 0;
    const y = Number(box.y) || 0;
    const width = Math.max(0, Number(box.width) || 0);
    const height = Math.max(0, Number(box.height) || 0);
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x + width);
    maxY = Math.max(maxY, y + height);
  });
  return {
    x: minX,
    y: minY,
    width: Math.max(0, maxX - minX),
    height: Math.max(0, maxY - minY),
  };
};

export const translateBoxes = ({ boxes = [], dx = 0, dy = 0 }) =>
  boxes.map((box) => ({
    ...box,
    x: box.x + dx,
    y: box.y + dy,
  }));

export const scaleBoxesToBounds = ({
  boxes = [],
  originBounds,
  nextBounds,
  minSize = 0.01,
}) => {
  if (!originBounds || !nextBounds) return boxes;
  const sx = originBounds.width > 0 ? nextBounds.width / originBounds.width : 1;
  const sy =
    originBounds.height > 0 ? nextBounds.height / originBounds.height : 1;
  return boxes.map((box) => ({
    ...box,
    x: nextBounds.x + (box.x - originBounds.x) * sx,
    y: nextBounds.y + (box.y - originBounds.y) * sy,
    width: Math.max(minSize, box.width * sx),
    height: Math.max(minSize, box.height * sy),
  }));
};

export const groupSelectionChrome = ({
  bounds,
  showHandles = true,
  color = GROUP_SELECTION_COLOR,
}) => {
  if (!bounds) return null;
  return {
    id: GROUP_SELECTION_ID,
    x: bounds.x,
    y: bounds.y,
    width: bounds.width,
    height: bounds.height,
    rotation: 0,
    color,
    name: "",
    showLabel: false,
    showHandles,
  };
};
